import { css } from '@emotion/react';
import styled from '@emotion/styled';
import tw from 'twin.macro';

export const StyledPagination = styled.nav`
  ${tw`pt-6`}
  ${tw`pb-10`}
  ${tw`lg:py-11`}
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`px-2`}
  ${tw`md:px-0`}
`;

export const StyledList = styled.ul<{ isCenteredOnMobile: boolean }>`
  ${tw`relative`}
  ${tw`flex`}
  ${tw`pt-[55px]`}
  ${tw`lg:pt-0`}
  ${tw`lg:justify-center`}
  ${tw`lg:gap-5`}

  ${({ isCenteredOnMobile }) =>
    isCenteredOnMobile
      ? css`
          ${tw`justify-center`}
          ${tw`gap-2`}
        `
      : tw`justify-between`}
`;
